<div class="backpage">
  <div class="flex flex-space-between align-items-center">
    <h2 class="page-header mat-headline">
      {{ integrationName }} ({{ productType }})
      {{ "APICreds.Details" | translate }}
    </h2>
  </div>
  <hr />
  <div class="flex details-page-container">
    <div class="info-box-container flex flex-column">
      <div class="card mat-elevation-z8">
        <div class="icon-container">
          <mat-icon>info_outline</mat-icon>
        </div>
        <div class="card-header">
          <h3 class="mat-headline title">Total Active Credentials</h3>
        </div>
        <div class="total-active-creds-value">
          <h3 class="mat-headline">{{ totalActiveCredentials }}</h3>
        </div>
      </div>
      <div class="card mat-elevation-z8">
        <div class="icon-container">
          <mat-icon>calendar_month</mat-icon>
        </div>
        <div class="card-header">
          <h3 class="mat-headline title">Billing Anniversary Date</h3>
        </div>
        <div class="billing-date-value">
          <h3>{{ datePipe.transform(anniversaryDate, "MM/dd/yyyy") }}</h3>
        </div>
      </div>
    </div>
    <div class="chart-section-container mat-elevation-z8">
      <div class="chart-container">
        <canvas id="APIChart"></canvas>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
  </div>
</div>
